import { ReactNode } from "react";

import ScrollableTable from "@/components/ScrollableTable";

/**
 * The labor and postpartum flowsheet grid. Rows stay compact, and below 800px of chart width the
 * table keeps every column and scrolls sideways inside its frame.
 */
export default function FlowsheetTable({ children }: { children: ReactNode }) {
  return (
    <ScrollableTable
      striped
      miw={800}
      withColumnBorders
      verticalSpacing={7}
      horizontalSpacing="xs"
      scrollProps={{ mt: "sm", bg: "white" }}
    >
      {children}
    </ScrollableTable>
  );
}
